import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableSkeleton from '../../../../src/components/SkeletonLoader/TableSkeleton';
import InfiniteScroll from '../../../../src/components/InfiniteScroll/InfiniteScroll';
import { ResourceUtils } from '../../assignments/components/questionDetailComponents/ResourceUtils';
import { useGetPersonalContentSetsMutation } from '../../../features/authentication/activitySearchApiSlice';
import { faCardsBlank, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import SortButtons from '../../../components/SortButtons';
import { NavLink } from 'react-router-dom';

const PersonalContentSet = () => {
  const [personalContentSets, setPersonalContentSets] = useState([]);
  const [isAscending, setIsAscending] = useState(true);
  const [noOfPersonalContentSets, setNoOfPersonalContentSets] = useState(0);
  const [skipValue, setSkipValue] = useState(0);
  const [scrollPersonalContentSetsList, setScrollPersonalContentSetsList] = useState([]);
  const [sortId, setSortId] = useState('description');
  const [isAtTop, setIsAtTop] = useState(false);
  const [nextCall, setNextCall] = useState(false);

  const limit = 30;
  const [getPersonalContentSets,{isLoading: isLoading}] = useGetPersonalContentSetsMutation();

  useEffect(() => {
    getPersonalContentSetsAsync(0, limit, false);
  }, []);
  
  const getPersonalContentSetsAsync = async (skip, take, isScrolling) => {
    const options = {
      skip: skip,
      take: take,
    };
    var response = await getPersonalContentSets(options);
    if(!response.error) {
      let updatedPersonalContentSetsList = response.data.data;
      setScrollPersonalContentSetsList(updatedPersonalContentSetsList);
      if(response.data.data.length < limit && isScrolling)
      {
        updatedPersonalContentSetsList = [...scrollPersonalContentSetsList, ...updatedPersonalContentSetsList];
        updatedPersonalContentSetsList = updatedPersonalContentSetsList.slice(response.data.data.length);
      }
      setPersonalContentSets(updatedPersonalContentSetsList);
      setNoOfPersonalContentSets(response.data.total);
    }
  };

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);
    let sortedPersonalContentSets = await ResourceUtils.customSort(personalContentSets, currentSortId, sortAsc);
    setPersonalContentSets(sortedPersonalContentSets);
    setIsAscending(sortAsc);
  };
  
  return (
    <>
      <div className='mt-3 whiteCard'>
        <h3 className="primary-title">
           Personal Content Sets{' '}
          <small className="opacity-50">({noOfPersonalContentSets})</small>
        </h3>
        <InfiniteScroll
          limit={limit}
          totalData={noOfPersonalContentSets}
          getData={getPersonalContentSetsAsync}
          setIsAtTop={setIsAtTop}
          nextCall={nextCall}
          setNextCall={setNextCall}
          skipValue={skipValue}
          setSkipValue={setSkipValue}>
          <table className='table'>
            {personalContentSets.length > 0 && !isLoading ? (
              <>
                <thead className='thead-light align-middle'>
                  <tr>
                    <th id='description' scope="col" className='fw-medium min-w-400 px-5' onClick={(e) => handleSort(e.currentTarget.id)}>
                      Description
                      <SortButtons
                        selectedSortId={sortId}
                        elementSortId={'description'}
                        isAscending={isAscending}
                      />
                    </th>
                    <th id='vocabularyCount' scope="col" className='fw-medium min-w-160' onClick={(e) => handleSort(e.currentTarget.id)}>
                          Vocabulary Count
                      <SortButtons
                        selectedSortId={sortId}
                        elementSortId={'vocabularyCount'}
                        isAscending={isAscending}
                      />
                    </th>
                    <th>
                      {'   '}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {isAtTop && nextCall && (
                    <tr>
                      <td colSpan='2'>
                        <div className='scroll-spinner mt-3 d-flex align-item-center justify-content-center'>
                          <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'>Load More</span>
                        </div>
                      </td>
                    </tr>
                  )}
                  {personalContentSets?.map((item, index) => (
                    <tr key={item.qsetId}>
                      <td className='w-min-max-250 text-truncate'>
                        <div className='d-flex align-items-center gap-2 px-4'>
                          <span className='me-2 icon-circle bg-assignmentIcon'>
                            <FontAwesomeIcon icon={faCardsBlank} color="#FFFFFF" /></span>
                          <span>{item.description}</span>
                        </div> </td>
                      <td>{item.vocabularyCount}</td>
                      <td>
                        <div className='d-flex justify-content-center align-items-center gap-2'>
                          <OverlayTrigger
                            key={`addQuestionToolTip${item.qsetId}`}
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">Add Vocabularies To Flashcard</Tooltip>}>
                            <NavLink
                              to={'pcsVocabularies'}
                              state={{ setId : item.qsetId }}>
                              <button
                                id={'addQuestions' + index}
                                className='btn grid-icon-btn success-icon-btn'
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </button>
                            </NavLink>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
            ) : isLoading ? (
              <>
                <TableSkeleton
                  colCount={3}
                  rowCount={4}
                />
              </>
            ) :
              <p className='text-danger'>There are no personal content sets available.</p>
            }
          </table>
        </InfiniteScroll>
      </div>
    </>
  );
};

export default PersonalContentSet;